<div class="row my-3">
    <div class="col-lg-12">
        <div class="card py-10 bg-white">
          <div class="row">
            <div class="col-lg-8">
                <div class="ms-4 me-2" style="height: 70px;">
                    <div class="skeleton-card" ></div>
                </div>
                <div class="ms-4 my-2 me-2 " style="height: 30px;">
                    <div class="skeleton-card" ></div>
                </div>
                <div class="ms-5 mt-4" style="height: 50px;">
                    <div class="skeleton-card" style="width: 200px;">

                    </div>
                </div>
            </div>
            <div class="col-lg-4">
               <div class="text-center mx-2 my-3" style="height: 200px; width: 200px;">
               
                <div class="skeleton-circle" >
                    
                </div>
               </div>
            </div>
          </div>
        </div>
    </div>
</div>